
import { throwError as observableThrowError, Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { ServiceBase } from '@app/services/base.service';

@Injectable()
export class PeticaoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  obterDocumentoComplento() {
    return this.http.get(this.URL_API + `peticao`);
  }

  adicionar(peticao: FormData) {
    return this.http.post(this.URL_API + 'peticao', peticao, { headers: { meta: ['upload'] } })
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  alterar(peticao: FormData) {
    return this.http.put(this.URL_API + 'peticao', peticao, { headers: { meta: ['upload'] } })
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }


  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `peticao/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `peticao/${id}`);
  }

  obterPorTags(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `peticao/obterTags`);
  }
  obterTodos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'peticao/');
  }

  obterPesquisa(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `peticao/pesquisar/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }


  obterArquivo(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `peticao/ObterModelo/${id}`);
  }


  gerarPeticao(processoId: number, id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processoGerarDoc/GerarPeticao/?processoId=${processoId}&id=${id}`);
  }


}
